import Firebase from '../modules/firebase'
import ENUM from '../assets/ENUM'
import Api from '../api'
import Store from '../store'
import Storage from '../helpers/storage'

const actions = {
    firebaseTimeBeforeBatch: 3000,
    timeoutFunction: function () {
    },

    sendNewslettersRequest() {
        if (Store.getters.actionsBatchTempUnsubscribe.length) {
            const senders = Store.getters.actionsBatchTempUnsubscribe
            Store.dispatch('updateActionsBatchTempUnsubscribe', [])
            Api.newsletters.unsubscribe(this.reduceActionInformations(senders))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
        }
        if (Store.getters.actionsBatchTempDelete.length) {
            const senders = Store.getters.actionsBatchTempDelete
            Store.dispatch('updateActionsBatchTempDelete', [])
            Api.newsletters.delete(this.reduceActionInformations(senders))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
        }
        if (Store.getters.actionsBatchTempKeep.length) {
            const senders = Store.getters.actionsBatchTempKeep
            Store.dispatch('updateActionsBatchTempKeep', [])
            Api.newsletters.keep(this.reduceActionInformations(senders))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
        }
        if (Store.getters.actionsBatchTempLater.length) {
            const senders = Store.getters.actionsBatchTempLater
            Store.dispatch('updateActionsBatchTempLater', [])
            Api.newsletters.sortLater(this.reduceActionInformations(senders))
                .catch(() => {
                    this.newslettersRequestError(senders)
                })
        }
    },

    reduceActionInformations(newsletters) {
        return newsletters.map(newsletter => ({email: newsletter.email, sender: newsletter.sender}))
    },

    requestAction({enumAction, senders}) {
        this.removeFromSendersList(senders)
        this.removeFromLaterList(senders)
        const cleanedSenders = senders
            .filter(item => {
                switch (item.type) {
                    case ENUM.NEWSLETTERS.CARDS.SHARING:
                    case ENUM.NEWSLETTERS.CARDS.MARKET:
                    case ENUM.NEWSLETTERS.CARDS.ANIMATION:
                        return false
                    default:
                        return true
                }
            })

        this.waitBeforeSend({enumAction, senders: cleanedSenders})

        return cleanedSenders.length
    },

    newslettersRequestError(array) {
        Store.dispatch('fillNewsletters', [...Store.getters.newsletters, ...array])
    },

    removeFromSendersList(newslettersToRemove) {
        this.checkNewslettersToRemove(newslettersToRemove)

        const newSubscriptions = Store.getters.newsletters.reduce((acc, subscriptionItem) => {
            // Search subscriptionItem in the newslettersToRemove
            if (!newslettersToRemove.find((removed) => {
                return (removed.sender === subscriptionItem.sender && removed.email === subscriptionItem.email)
            })) {
                // We can keep subscriptionItem because not in newslettersToRemove
                acc.push(subscriptionItem)
            }
            return acc
        }, [])

        Store.dispatch('fillNewsletters', newSubscriptions)
    },

    removeFromLaterList(newslettersToRemove) {
        this.checkNewslettersToRemove(newslettersToRemove)

        const newLater = Store.getters.laterList.reduce((acc, laterItem) => {
            // Search laterItem in the newslettersToRemove
            if (!newslettersToRemove.find((removed) => {
                return (removed.sender === laterItem.sender && removed.email === laterItem.email)
            })) {
                // We can keep laterItem because not in newslettersToRemove
                acc.push(laterItem)
            }
            return acc
        }, [])

        Store.dispatch('fillLaterList', newLater)
    },

    checkNewslettersToRemove(newslettersToRemove) {
        newslettersToRemove.forEach(newsletter => {

            // if special card is removed, we store it in the local storage
            if (newsletter.name && (newsletter.name === ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONA || newsletter.name === ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONB)) {
                Storage.setItem(newsletter.name, true)
            }
        })
    },

    waitBeforeSend({enumAction, senders}) {

        switch (enumAction) {
            case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                Store.dispatch('updateActionsBatchTempUnsubscribe', [...Store.getters.actionsBatchTempUnsubscribe, ...senders])
                break
            case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                Store.dispatch('updateActionsBatchTempKeep', [...Store.getters.actionsBatchTempKeep, ...senders])
                break
            case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                Store.dispatch('updateActionsBatchTempDelete', [...Store.getters.actionsBatchTempDelete, ...senders])
                break
            case ENUM.NEWSLETTERS.ACTIONS.LATER:
                Store.dispatch('updateActionsBatchTempLater', [...Store.getters.actionsBatchTempLater, ...senders])
                break
        }

        this.restartCounter()
    },

    restartCounter() {
        this.clearCounter()
        this.startCounter()
    },

    startCounter() {
        this.timeoutFunction = setTimeout(() => {
            this.sendNewslettersRequest()
        }, this.firebaseTimeBeforeBatch)
    },

    clearCounter() {
        clearInterval(this.timeoutFunction)
    }

}

Firebase.getValue('action_delay_seconds', Firebase.TYPES.NUMBER)
    .then(stringTime => {
        const numberTime = parseInt(stringTime, 10)
        if (numberTime) {
            actions.firebaseTimeBeforeBatch = numberTime * 1000
        }
    })
    .catch()

export default actions
